import { render, staticRenderFns } from "./OsmDetalhados.vue?vue&type=template&id=5e1a13ee&lang=pug&"
import script from "./OsmDetalhados.vue?vue&type=script&lang=js&"
export * from "./OsmDetalhados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports